import PropTypes from 'prop-types';
import React, { useMemo, useState } from 'react';
import { Search, ColorBadge, Theme } from '@spoiler-alert/ui-library';
import { createUseStyles } from 'react-jss';
import { VTable, VColumn, VRowAction } from '../../components/v-table';
import routePaths from '../../route-paths';
import { siteProp } from './editing/site-editing-helpers';

const useStyles = createUseStyles({
  wrap: {
    position: 'relative',
  },
  header: {
    padding: 10,
    display: 'flex',
    gap: 10,
    borderBottom: `1px solid ${Theme.grey10}`,
  },
});

const SiteList = ({ orgSiteId, sitesList, history, loading }) => {
  const classes = useStyles();
  const [searchText, setSearchText] = useState('');

  const siteColumns = useMemo(() => {
    return [
      new VColumn({
        field: '_id',
        displayName: 'ID',
        sortable: true,
      }),
      new VColumn({
        field: 'itemImportSite',
        displayName: 'Import Site Name',
        sortable: true,
      }),
      new VColumn({
        field: 'siteName',
        displayName: 'Site Name',
        sortable: true,
        defaultSort: true,
        defaultSortDirection: 'asc',
        formatter: (value, row) => (
          <span>
            <span>{value}</span> {row.archived ? <ColorBadge theme="grey">Archived</ColorBadge> : ''}
          </span>
        ),
      }),
      new VColumn({
        field: 'siteType',
        displayName: 'Site Type',
        sortable: true,
      }),
      new VColumn({
        field: 'physicalAddress.content',
        displayName: 'Address',
        sortable: true,
      }),
    ];
  }, []);

  const handleRowClick = (row) => {
    history.push(`${routePaths.sites}/${orgSiteId}/${row._id}`);
  };

  const handleSearch = (text) => {
    setSearchText(text);
  };

  return (
    <div className={classes.wrap}>
      <div className={classes.header}>
        <Search onChange={handleSearch} className={classes.search} />
      </div>
      <VTable
        cols={siteColumns}
        data={sitesList}
        loading={loading}
        searchText={searchText}
        rowActionsWidth={120}
        rowActions={[
          <VRowAction
            key="edit"
            label="Site Details"
            onClick={(row) => () => handleRowClick(row)}
            tooltipText="Edit Site"
          />,
        ]}
      />
    </div>
  );
};

SiteList.propTypes = {
  sitesList: PropTypes.arrayOf(siteProp),
  history: PropTypes.object,
  orgSiteId: PropTypes.string,
  loading: PropTypes.bool,
};

export default SiteList;
